import i18next from 'i18next';
import {lazy} from 'react';
import {getExactRoute} from 'util/react';

import EN from './i18n/en.json';
import LT from './i18n/lt.json';

i18next.addResourceBundle('en', 'settings', EN);
i18next.addResourceBundle('lt', 'settings', LT);

export const SettingsListRoute = getExactRoute('settings', 'menu.main', '/settings', lazy(() => import('./layout/SettingsLayout')), null, ['admin']);

const SettingsRoute = (
  <>
    {SettingsListRoute}
  </>
);

export default SettingsRoute;
